import { OverlayContainer } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';
import { ModalHelperServiceBase } from 'webcommon/core-ui/modals-ng1520';

@Injectable({
  providedIn: 'root',
})
export class ModalHelperService extends ModalHelperServiceBase {
  private overlayContainer = inject(OverlayContainer);

  public appendModalOverrideClass(element: Element) {
    // this is a hack, see notes in emds-modal.less
    element.parentElement?.parentElement?.parentElement?.classList.add('modal-top');

    // this call is paired with ApModalHelper.makeCompatibleWithBootstrapModalOnDestroy(),
    // and ideally this code would live there instead if it didn't require extra refactoring
    this.overlayContainer.getContainerElement().classList.add('modal-container-top');
  }
}
